import { z } from '@bonanza-social/toolkit/api';
import { PromoTargetSchema } from '../../services/PromosService.schemas';
import icons from '@bonanza-social/moonlight/lib/assets/icons';

export const rewardBadgeMap: Partial<
  Record<z.infer<typeof PromoTargetSchema>, keyof typeof icons>
> = {
  FreeSpins: 'freeSpins',
  Coins: 'bonanzaCoin',
  InstantWheel: 'rewardWheel',
  Cash: 'bonanzaDollar',
  Wheel: 'metaWheel',
  Scratcher: 'scratchcards',
};
